<!-- 喵牌 -->
<template>
<div class="game-scratch-page">
  <div class="head_area">
    <div class="leftImg">
      <img @click="back" src="/static/image/icon-jiantou@2x.eb0b501e01e95b720b727b63a23960e3.png" class="top_back">
    </div>
    <span class="head_text"></span>
    <span class="right_menu"></span>
  </div>
  <div class="content">
    <div class="scratch-box" >
      <div class="game-result-tips">{{ $t('第') }} {{ sequence_info.sequencenum }} {{ $t('期开奖结果') }}</div>
      <div class="eraser">
        <div class="scratch-card scratch" style="width: 100%; height: 100%;">
          <scratch-card
            ref="scratch"
            :brush-size="50"
            :cover-color="'#434444'"
          />
        </div>
        <b class="text blue-bg">{{ sequence_info.outcome_arr[0] }}</b> +
        <b class="text blue-bg">{{ sequence_info.outcome_arr[1] }}</b> +
        <b class="text blue-bg">{{ sequence_info.outcome_arr[2] }}</b> =
        <b :class="['text', sequence_info.outcome_arr[3] >= 14 ? 'red-bg' : 'green-bg']">{{ sequence_info.outcome_arr[3] }}</b>
        <span class="type">{{sequence_info.outcome_arr[3] >= 14 ? $t('大') : $t('小')}}, {{sequence_info.outcome_arr[3] % 2 === 1 ? $t('单') : $t('双')}}</span>
      </div>
      <div class="curren-num">{{ $t('当前第') }}{{ sequence_info.sequencenum }}</div>
      <div class="next-time">
        <span>{{ minute }}</span>{{ $t('分') }}<span>{{ second }}</span>{{ $t('秒') }}
      </div>
      <div class="time-title">{{ $t('距离开奖') }}</div>

      <div class="btn finish-btn" @click="getSequenceNum()">{{ $t('刷新') }}</div>
      <div class="btn back-btn" @click="back()">{{ $t('返回') }}</div>

    </div>
  </div>
</div>
</template>

<script>
import ScratchCard from '@/components/ScratchCard.vue';
import { translateText } from "../../common/utils"

export default {
  name: 'scratch',
  data() {
    return {
      game_video: 'jld28',
      totalSeconds: 0, // 倒計時總秒數 (例如 3分鐘)
      minute: '00',
      second: '00',
      timer: null,
      time_interval: null,
      sequence_info: {
        outcome_arr: []
      },

    }
  },
  components: {
    ScratchCard
  },
  mounted() {
    this.getSequenceNum()

  },
  methods: {
    back(){
      window.history.go(-1)
    },
    async showTost(type, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    getSequenceNum() {
      this.$nextTick(() => {
        this.resetScratch()
      })
      this.$parent.showLoading()
      this.$apiFun
        .post('/api/game/ajaxSequencenum', {
          video_both: this.game_video,
          sequencenum_span: ''
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            if(res.data && Object.keys(res.data).length > 0) {
              this.stopTimer()
              const info =  res.data
              info.outcome_arr = info.outcome.split('-')

              this.sequence_info = info


              const starttime = parseInt(info.sealing_plate)
              const fwq_time = parseInt(info.fwq_time)

              var elapsed = Math.floor((Date.now() -  Date.now()) / 1000);
              const nowtime = fwq_time + elapsed;

              // 剩余秒数
              const time = starttime - nowtime;
              this.totalSeconds = time
              this.startCountdown()

            }else {
              setTimeout(() => {
                this.getSequenceNum()
              }, 3000);
            }
          }
          this.$parent.hideLoading()
        })
        .catch(res => {
          this.$parent.hideLoading()
        });
    },
    startCountdown() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (this.totalSeconds > 0) {
          this.totalSeconds--
          const m = Math.floor(this.totalSeconds / 60)
          const s = this.totalSeconds % 60
          this.minute = String(m).padStart(2, '0')
          this.second = String(s).padStart(2, '0')
        } else {
          clearInterval(this.timer)
          this.timer = null
          this.startTimer()

        }
      }, 1000)
    },
    startTimer() {
      if (this.time_interval) {
        clearInterval(this.time_interval)
      }
      this.time_interval = setInterval(() => {
        this.getSequenceNum()
      }, 6000)
    },
    stopTimer() {
      if (this.time_interval) {
        clearInterval(this.time_interval)
        this.time_interval = null
      }
    },
    // 重置刮刮乐
    resetScratch() {
      this.$refs.scratch.reset();
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.stopTimer();
  },
  deactivated() {
    clearInterval(this.timer)
    this.stopTimer();
  }
}
</script>

<style scoped lang="scss">
.game-scratch-page {
  background-image: url("/static/image/new/game/game-room-bg3.png");
  background-size: 100% 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: #fff;
  font-family: PingFang SC, PingFang SC;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: right;
      transform: rotate(180deg);
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.438rem;
      font-weight: bold;
      font-family: PingFang SC;
      color: #fff;
      width: 80%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      font-family: PingFang SC;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    padding: 2rem .4rem 0;
    .scratch-box {
      background: rgba(22, 41, 23, 0.3);
      border: .02rem solid #3a4760;
      border-radius: .6rem;
      padding: 0.64rem .43rem .56rem;
      text-align: center;
      .game-result-tips {
        font-family: HYYakuHei, HYYakuHei;
        font-size: 0.48rem;
        background: linear-gradient(to right, #007AFF 0%, #FFFFFF 60%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .eraser {
        height: 2.91rem;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0.02rem solid #434444;
        margin-top: .53rem;
        font-size: .43rem;
        .scratch-card {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }
        .text {
          width: .86rem;
          height: .86rem;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          font-size: 0.43rem;
          margin: 0 .15rem;
        }
        .type {
          font-size: .35rem;
        }
        .green-bg {
          background: linear-gradient( 180deg, #00E137 0%, #00C400 47%, #00DC00 100%);
        }
        .red-bg {
          background: linear-gradient( 180deg, #FF5861 0%, #EC2627 47%, #FB3E38 100%);
        }
        .blue-bg {
          background: linear-gradient( 180deg, #99CFFF 0%, #7D9BFD 47%, #388BF6 100%);
        }
      }
      .curren-num {
        font-size: 0.43rem;
        color: #A8D3FF;
        margin-top: .53rem;
      }
      .next-time {
        font-size: .53rem;
        margin: .53rem 0 .11rem;
        span {
          color: #FFC800;
          font-size: .69rem;
          margin: 0 .12rem;
          font-family: Gilroy-Medium;
        }
      }
      .time-title {
          color: #9A9A9A;
          font-size: .43rem;
      }
      .btn {
        height: 1.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #007AFF;
        margin-top: .37rem;
        font-weight: 600;
        font-size: 0.43rem;
        &.back-btn {
          background: #FF905F;
          margin-top: .27rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/scratch.vue